// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"805dc4d9b9e73a8f792e","678":"5abbf649a6a0f6f0b5a2","682":"dbdc8c86a41bd07f4ed6","883":"d1cfdf98f5f5ad57f29f"}[chunkId] + ".js";
};